import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#F3F4F6] border-t border-gray-200 py-3 text-center">
      <p className="text-sm text-[#6B7280]">© 2025 Hamrith Consulting Services LLP (HCS). All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
